module.exports = __webpack_public_path__ + "img/grafica_mercado_B2C.b15f1fbd.png";